import { render, staticRenderFns } from "./terminos-condiciones.vue?vue&type=template&id=41b468ec&scoped=true&"
import script from "./terminos-condiciones.vue?vue&type=script&lang=js&"
export * from "./terminos-condiciones.vue?vue&type=script&lang=js&"
import style0 from "./terminos-condiciones.vue?vue&type=style&index=0&id=41b468ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b468ec",
  null
  
)

export default component.exports